import { useAuthStore } from '../auth/authStore'
import { EmptyState } from '../../shared/ui/EmptyState'
import { ProcurementQueuePage } from './ProcurementQueuePage'
import { canOpenQueue } from './queueAccess'

/**
 * Гейт раздела «Очередь квот». С 18.09.2026 он закрыт для ADMIN (решение
 * Сергея, п. 11 встречи 17.09): у заказчика-администратора очередь была забита
 * позициями матриц Склад/РФ/Стоки, которые закупка не ведёт. Пункт меню админу
 * не показывается, API отдаёт 403 — эта заглушка нужна для прямой ссылки или
 * старой закладки, чтобы вместо ошибки было понятное объяснение.
 */
export function QueueRouteGuard() {
  const { user } = useAuthStore()
  // Белый список: нынешние роли, кроме ADMIN (canOpenQueue — то же правило у
  // ссылок в очередь). Раньше закрыт был только ADMIN — любая другая роль (в
  // том числе роли этапа 3) получала страницу очереди.
  if (!canOpenQueue(user?.role)) {
    return (
      <div className="p-6">
        <EmptyState
          title="Раздел недоступен"
          description="«Очередь квот» ведут закупщики, РОЗ и генеральный директор."
        />
      </div>
    )
  }
  return <ProcurementQueuePage />
}
